module.exports = function() {
  return new Worker(__webpack_public_path__ + "d4d48f3e65c0ece863c6.worker.js");
};